import FormWidget from './form-widget';

export default FormWidget;
